var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHelp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icHelp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-Upgrade-Unverify",
    transform: "translate(-17.000000, -579.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(18.000000, 580.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icHelp"
  }, /*#__PURE__*/React.createElement("g", {
    id: "round",
    transform: "translate(8.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.319875,
    cy: 13.453125,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61270703,4.25947266 C8.59471484,1.90763672 6.67589453,0 4.319875,0 C1.95272656,0 0.02690625,1.92582031 0.02690625,4.29296875 C0.02690625,4.59500781 0.271742188,4.83984375 0.57378125,4.83984375 C0.875820313,4.83984375 1.12065625,4.59500781 1.12065625,4.29296875 C1.12065625,2.52891406 2.55582031,1.09375 4.319875,1.09375 C6.08392969,1.09375 7.51909375,2.52891406 7.51909375,4.29296875 C7.51909375,4.30270312 7.51933984,4.31238281 7.51985938,4.32200781 C7.50878516,5.5951875 6.74802734,6.73777344 5.57517188,7.23851953 C4.48038281,7.70593359 3.773,8.78822656 3.773,9.99583594 L3.773,11.265625 C3.773,11.5676641 4.01783594,11.8125 4.319875,11.8125 C4.62191406,11.8125 4.86675,11.5676641 4.86675,11.265625 L4.86675,9.99583594 C4.86675,9.22701172 5.31338281,8.5395625 6.00463281,8.24444141 C7.58999609,7.56757422 8.61412891,6.0165 8.61371887,4.29283203 C8.61371887,4.28162109 8.61336328,4.27051953 8.61270703,4.25947266 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,0 C5.60708008,0 0,5.60761719 0,12.5 C0,19.3923828 5.60708008,25 12.5,25 C19.3929199,25 25,19.3923828 25,12.5 C25,5.60761719 19.3929199,0 12.5,0 Z M12.5,24.1071429 C6.09979095,24.1071429 0.892857143,18.9002091 0.892857143,12.5 C0.892857143,6.09979095 6.09979095,0.892857143 12.5,0.892857143 C18.9002091,0.892857143 24.1071429,6.09979095 24.1071429,12.5 C24.1071429,18.9002091 18.9002091,24.1071429 12.5,24.1071429 Z",
    id: "Shape",
    stroke: "#333333",
    strokeWidth: 0.3
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHelp);
export default __webpack_public_path__ + "static/media/icHelp.088883105eb38e6fa854138d66a89ab7.svg";
export { ForwardRef as ReactComponent };